import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "User List", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Sort by UID")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Sort by Display Name")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Sort by Display Email")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Sort by Display Role")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h1", null, "Job List", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppBtn = _resolveComponent("AppBtn")!
  const _component_UserList = _resolveComponent("UserList")!
  const _component_JobList = _resolveComponent("JobList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", null, "Use Mouse " + _toDisplayString(`X:${_ctx.x}, Y:${_ctx.y}`), 1),
    _createElementVNode("h3", null, "Use Window size " + _toDisplayString(`(${_ctx.width}, ${_ctx.height})`), 1),
    _createElementVNode("h3", null, "Use Breakpoints Vuetify " + _toDisplayString(_ctx.breakpoints.greater('xs')), 1),
    (_ctx.alertWindow)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_2, "Alert"))
      : _createCommentVNode("", true),
    _hoisted_3,
    _createVNode(_component_AppBtn, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleClick('uid')))
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }),
    _createVNode(_component_AppBtn, {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleClick('displayName')))
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }),
    _createVNode(_component_AppBtn, {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleClick('email')))
    }, {
      default: _withCtx(() => [
        _hoisted_6
      ]),
      _: 1
    }),
    _createVNode(_component_AppBtn, {
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleClick('role')))
    }, {
      default: _withCtx(() => [
        _hoisted_7
      ]),
      _: 1
    }),
    _createVNode(_component_UserList, {
      users: _ctx.users,
      order: _ctx.order
    }, null, 8, ["users", "order"]),
    _hoisted_8,
    _hoisted_9,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobs, (job) => {
      return (_openBlock(), _createBlock(_component_JobList, {
        key: job.uid,
        job: job
      }, null, 8, ["job"]))
    }), 128))
  ]))
}